import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Eyebrow, Section } from '../ui/Section';
type Tomo = {
  n: number;
  title: string;
  subtitle: string;
  includes: string[];
};
const tomos: Tomo[] = [{
  n: 1,
  title: 'Fundamentos',
  subtitle: 'La base que nadie te enseña',
  includes: ['Rueda cromática completa', 'Temperatura de color aplicada a la piel', 'Matiz, saturación y luminosidad', 'Cómo leer un rostro antes de maquillar']
}, {
  n: 2,
  title: 'Diagnóstico de Subtono',
  subtitle: 'El paso más crítico',
  includes: ['Test de subtono cálido, frío y neutro', 'Lectura de venas, joyería y luz natural', 'Errores comunes al diagnosticar']
}, {
  n: 3,
  title: 'Armocromía: 4 Estaciones',
  subtitle: 'Paletas exactas por clienta',
  includes: ['Primavera, Verano, Otoño e Invierno', 'Paletas listas para aplicar por estación', 'Cómo identificar la estación real']
}, {
  n: 4,
  title: 'Corrección de Color',
  subtitle: 'Ojeras, rojeces y manchas',
  includes: ['Qué corrector usar y por qué', 'Neutralización según problemática', 'Secuencia de aplicación correcta']
}, {
  n: 5,
  title: 'Pieles Difíciles',
  subtitle: 'Madura, clara, oscura o con acné',
  includes: ['Piel madura y con textura', 'Tonos muy oscuros y muy claros', 'Acné activo y manchas']
}, {
  n: 6,
  title: 'Errores y Soluciones',
  subtitle: 'Casos reales resueltos',
  includes: ['Los errores que arruinan un diagnóstico', 'Cómo corregir sobre la marcha', 'Casos reales explicados']
}];
export function Tomos() {
  const [open, setOpen] = useState<number | null>(null);
  return <Section id="tomos" className="bg-blush" data-id="element-260" data-mp="p3bfxmmvnfhc">
      <div className="mx-auto max-w-2xl text-center" data-id="element-261" data-mp="p20i03g451y5"><Eyebrow data-id="element-262" data-mp="l3atpftjdzzq">Contenido completo · 6 tomos</Eyebrow><h2 className="mt-2 font-display text-3xl font-semibold leading-tight text-ink sm:mt-3 sm:text-4xl" data-id="element-263" data-mp="l0euzp9v77a8">Tu hoja de ruta para dominar el color</h2><p className="mt-2 text-xs text-plum/80 sm:mt-3 sm:text-sm" data-id="element-264" data-mp="b3sc3613mqau">Tocá un tomo para ver qué incluye.</p></div>
      <div className="mx-auto mt-6 grid max-w-3xl grid-cols-1 gap-2 sm:mt-10 sm:gap-3" data-id="element-265" data-mp="1ggaql3656mc">
        {tomos.map(tomo => {
        const isOpen = open === tomo.n;
        return <div key={tomo.n} className={`overflow-hidden rounded-xl shadow-sm ring-1 transition-colors sm:rounded-2xl ${isOpen ? 'bg-white ring-rosegold/30' : 'bg-white/80 ring-rosegold/10'}`} data-id="element-266" data-mp="3nnxsu9a4ho64">
            <button onClick={() => setOpen(isOpen ? null : tomo.n)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-3.5 py-3 text-left sm:gap-4 sm:px-5 sm:py-4" data-id="element-267" data-mp="3sou3r6sw6al1">
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-display text-base font-semibold sm:h-11 sm:w-11 sm:text-lg ${isOpen ? 'bg-rosegold text-white' : 'bg-ink text-cream'}`} data-id="element-268" data-mp="p8da3cpfm66k">{tomo.n}</span>
              <span className="min-w-0 flex-1" data-id="element-269" data-mp="136bkk70mtigs"><span className="block font-display text-base font-semibold leading-tight text-ink sm:text-lg" data-id="element-270" data-mp="135a0jd1n1lmx">Tomo {tomo.n} — {tomo.title}</span><span className="mt-0.5 block truncate text-[11px] text-plum/75 sm:text-sm" data-id="element-271" data-mp="17yv0hamskpor">{tomo.subtitle}</span></span>
              <ChevronDownIcon className={`h-4 w-4 shrink-0 text-rosegold transition-transform sm:h-5 sm:w-5 ${isOpen ? 'rotate-180' : ''}`} data-id="element-272" data-mp="2no420ngp4236" />
            </button>
            <AnimatePresence initial={false} data-id="element-273" data-mp="32ch29wmtg73h">{isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} data-id="element-274" data-mp="2xe5q3f91tki3"><ul className="grid gap-1.5 border-t border-blush px-4 py-3 text-xs text-plum sm:grid-cols-2 sm:gap-2 sm:px-5 sm:py-4 sm:text-sm" data-id="element-275" data-mp="29njifp2yi28m">{tomo.includes.map(item => <li key={item} className="flex gap-2" data-id="element-276" data-mp="24rkz4fwhjaf2"><span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-rose" data-id="element-277" data-mp="2ipj2kq99pmfs" />{item}</li>)}</ul></motion.div>}</AnimatePresence>
          </div>;
      })}
      </div>
    </Section>;
}